import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Transition as _Transition, vShow as _vShow, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "login pt-5" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col mb-4" }
const _hoisted_5 = { class: "container" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-12 col-sm-4" }
const _hoisted_8 = { class: "title login__title" }
const _hoisted_9 = {
  for: "email",
  class: "label"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" E-mail: ")
const _hoisted_11 = {
  for: "email",
  class: "label"
}
const _hoisted_12 = {
  key: 0,
  class: "errorlogin"
}
const _hoisted_13 = { class: "button button--primary form__button" }
const _hoisted_14 = { class: "col-12 col-sm-6 offset-sm-2" }
const _hoisted_15 = /*#__PURE__*/_createVNode("h2", { class: "title login__title login__title-1 section__title" }, null, -1)
const _hoisted_16 = { class: "title login__title" }
const _hoisted_17 = {
  key: 0,
  id: "myModal",
  class: "modal"
}
const _hoisted_18 = { class: "modal-content" }
const _hoisted_19 = { class: "modalcontent" }
const _hoisted_20 = { class: "modalcontent__h2" }
const _hoisted_21 = { class: "modalcontent__margin" }
const _hoisted_22 = /*#__PURE__*/_createVNode("p", { class: "modalcontent__text-info" }, "E-mail", -1)
const _hoisted_23 = { class: "modalcontent__text-info" }
const _hoisted_24 = {
  for: "email",
  class: "label"
}
const _hoisted_25 = { class: "modalcontent__text-info" }
const _hoisted_26 = {
  for: "email",
  class: "label"
}
const _hoisted_27 = {
  class: "button button--primary form__button auth-button--primary",
  type: "submit"
}
const _hoisted_28 = {
  key: 0,
  id: "myModal",
  class: "modal"
}
const _hoisted_29 = { class: "modal-content" }
const _hoisted_30 = { class: "modalcontent" }
const _hoisted_31 = { class: "modalcontent__h2" }
const _hoisted_32 = { class: "modalcontent__margin modalcontent__margin-faq" }
const _hoisted_33 = {
  id: "myModal",
  class: "modal"
}
const _hoisted_34 = { class: "modal-content" }
const _hoisted_35 = { class: "modalcontent" }
const _hoisted_36 = /*#__PURE__*/_createVNode("h2", { class: "modalcontent__h2" }, "Восстановить пароль", -1)
const _hoisted_37 = { class: "modalcontent__margin modalcontent__margin-faq" }
const _hoisted_38 = { class: "fx" }
const _hoisted_39 = /*#__PURE__*/_createVNode("p", { class: "" }, "Введите почту *", -1)
const _hoisted_40 = { class: "error-message" }
const _hoisted_41 = { class: "error-message" }
const _hoisted_42 = { class: "success-modal" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_modal = _resolveComponent("modal")
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_modal),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_router_link, {
              to: "../",
              class: "link login__link"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_svg_icon, { name: "arrow-right" }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('login.back')), 1 /* TEXT */)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode("h2", _hoisted_8, _toDisplayString(_ctx.$t('login.lk')), 1),
            _createVNode("form", {
              onSubmit: _cache[4] || (_cache[4] = _withModifiers((...args) => (_ctx.signIn(...args)), ["prevent"])),
              class: "form login__form"
            }, [
              _createVNode("label", _hoisted_9, [
                _hoisted_10,
                _withDirectives(_createVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.email = $event)),
                  class: "input",
                  type: "email",
                  name: "email",
                  id: "email",
                  placeholder: "Введите электронный адрес"
                }, null, 512), [
                  [_vModelText, _ctx.email]
                ])
              ]),
              _createVNode("label", _hoisted_11, [
                _createTextVNode(_toDisplayString(_ctx.$t('login.pwd')) + " ", 1 /* TEXT */),
                _withDirectives(_createVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.password = $event)),
                  ref: "inputPassword",
                  class: "input",
                  type: "password",
                  name: "password",
                  id: "password",
                  placeholder: "Введите пароль"
                }, null, 512), [
                  [_vModelText, _ctx.password]
                ]),
                _createVNode(_component_svg_icon, {
                  onClick: _ctx.togglePasswordAttribute,
                  name: "input-eye"
                }, null, 8, ["onClick"])
              ]),
              _createVNode("div", {
                class: "link mb-4 cursor",
                onClick: _cache[3] || (_cache[3] = $event => (_ctx.forgotPassword()))
              }, _toDisplayString(_ctx.$t('login.forgotPassword')), 1),
              (_ctx.loginactive)
                ? (_openBlock(), _createBlock("p", _hoisted_12, _toDisplayString(_ctx.$t('login.errorLogin')), 1))
                : _createCommentVNode("", true),
              _createVNode("button", _hoisted_13, _toDisplayString(_ctx.$t('main.enter')), 1)
            ], 32)
          ]),
          _createVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode("h2", _hoisted_16, _toDisplayString(_ctx.$t('login.create')), 1),
            _createVNode("button", {
              class: "button button--primary form__button",
              onClick: _cache[5] || (_cache[5] = $event => (_ctx.active = !_ctx.active))
            }, _toDisplayString(_ctx.$t('login.reg')), 1),
            _createVNode(_Transition, { name: "slide-fade" }, {
              default: _withCtx(() => [
                (_ctx.active)
                  ? (_openBlock(), _createBlock("div", _hoisted_17, [
                      _createVNode("div", _hoisted_18, [
                        _createVNode("form", {
                          onSubmit: _cache[10] || (_cache[10] = _withModifiers((...args) => (_ctx.registor(...args)), ["prevent"])),
                          class: "form login__form"
                        }, [
                          _createVNode("span", {
                            class: "close auth-close",
                            onClick: _cache[6] || (_cache[6] = $event => (_ctx.active = !_ctx.active))
                          }, "×"),
                          _createVNode("div", _hoisted_19, [
                            _createVNode("h2", _hoisted_20, _toDisplayString(_ctx.$t('login.regis')), 1),
                            _createVNode("div", _hoisted_21, [
                              _hoisted_22,
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                class: "modalcontent__input",
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (_ctx.regisemail = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.regisemail]
                              ]),
                              _createVNode("p", _hoisted_23, _toDisplayString(_ctx.$t('login.rpwd')), 1),
                              _createVNode("label", _hoisted_24, [
                                _withDirectives(_createVNode("input", {
                                  type: "password",
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (_ctx.regispassword = $event)),
                                  ref: "inputPassword1",
                                  class: "modalcontent__input",
                                  name: "regispassword",
                                  id: "regispassword"
                                }, null, 512), [
                                  [_vModelText, _ctx.regispassword]
                                ]),
                                _createVNode(_component_svg_icon, {
                                  onClick: _ctx.togglePasswordAttribute1,
                                  name: "input-eye",
                                  class: "login-regis"
                                }, null, 8, ["onClick"])
                              ]),
                              _createVNode("p", _hoisted_25, _toDisplayString(_ctx.$t('login.confirmPwdRegistration')), 1),
                              _createVNode("label", _hoisted_26, [
                                _withDirectives(_createVNode("input", {
                                  type: "password",
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => (_ctx.regispassword_repl = $event)),
                                  ref: "inputPassword2",
                                  class: "modalcontent__input",
                                  name: "regispassword2",
                                  id: "regispassword2"
                                }, null, 512), [
                                  [_vModelText, _ctx.regispassword_repl]
                                ]),
                                _createVNode(_component_svg_icon, {
                                  class: "login-regis",
                                  onClick: _ctx.togglePasswordAttribute2,
                                  name: "input-eye"
                                }, null, 8, ["onClick"])
                              ]),
                              _createVNode("button", _hoisted_27, _toDisplayString(_ctx.$t('login.reg')), 1)
                            ])
                          ])
                        ], 32)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_Transition, { name: "slide-fade" }, {
              default: _withCtx(() => [
                (_ctx.active1)
                  ? (_openBlock(), _createBlock("div", _hoisted_28, [
                      _createVNode("div", _hoisted_29, [
                        _createVNode("span", {
                          class: "close close__successful",
                          onClick: _cache[11] || (_cache[11] = $event => (_ctx.active1 = !_ctx.active1))
                        }, "×"),
                        _createVNode("div", _hoisted_30, [
                          _createVNode("h2", _hoisted_31, _toDisplayString(_ctx.$t('login.loginSuccessful')), 1),
                          _createVNode("div", _hoisted_32, [
                            _createVNode("button", {
                              class: "button button--primary form__button form__button1",
                              onClick: _cache[12] || (_cache[12] = $event => (_ctx.active1 = !_ctx.active1))
                            }, " ок ")
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_Transition, { name: "slide-fade" }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode("div", _hoisted_33, [
                  _createVNode("div", _hoisted_34, [
                    _createVNode("span", {
                      class: "close close__successful",
                      onClick: _cache[13] || (_cache[13] = $event => {
                    ;(_ctx.forgotIsActive = !_ctx.forgotIsActive), (_ctx.success = false)
                  })
                    }, "×"),
                    _createVNode("div", _hoisted_35, [
                      _hoisted_36,
                      _createVNode("div", _hoisted_37, [
                        _withDirectives(_createVNode("div", _hoisted_38, [
                          _hoisted_39,
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "modalcontent__input",
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => (_ctx.forgotEmail = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.forgotEmail]
                          ]),
                          _withDirectives(_createVNode("p", _hoisted_40, " Почта не зарегистрирована ", 512), [
                            [_vShow, _ctx.notFoundEmail]
                          ]),
                          _withDirectives(_createVNode("p", _hoisted_41, " Электронная почта должна быть действующим адресом электронной почты. ", 512), [
                            [_vShow, _ctx.errorEmail]
                          ]),
                          _createVNode("button", {
                            class: "button button--primary form__button form__button1",
                            onClick: _cache[15] || (_cache[15] = $event => (_ctx.getEmail()))
                          }, " далее ")
                        ], 512), [
                          [_vShow, !_ctx.success]
                        ]),
                        _withDirectives(_createVNode("h3", _hoisted_42, " Ссылка для восстановления пароля отправлена на данную почту ", 512), [
                          [_vShow, _ctx.success]
                        ])
                      ])
                    ])
                  ])
                ], 512), [
                  [_vShow, _ctx.forgotIsActive]
                ])
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}